<template>
	<div>
		<transition name="fade">
      <template v-if="Object.keys(selected_card).length > 0">
        <div class="position-relative" style="z-index: 1035">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0;">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-white">
                      <div class="w-100 popup-full">
                        <div class="">
                          <div class="container py-3 px-4 box-shadow-nav position-absolute bg-white z-index-1038">
                            <img src="../../../../assets/img/icon/close.png" class="cursor-pointer d-inline-block" width="15" style="z-index: 1049" @click="close">
                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 d-inline-block">{{selected_card.card_name}} {{$t('hotel.concierge.member-detail')}}</p>
                          </div>
                          <!-- card -->
                          <div style="height: 60px"></div>
                          <div class="container px-4 mt-2 mb-4">
                            <div class="mb-3 mt-4">
                              <div class="">
                               <MemberCard :data="parsingDataCard(selected_card)" :guest_name="guest_name"></MemberCard>
                              </div> 
                            </div>
                            <!-- List -->
                            <div class="py-3 mt-4">
                              <div class="pb-3">
                                <div class="row no-gutters">
                                  <div class="col-12 col-md-12">
                                    <p class="mb-0 font-bold text-20 body-2-2">{{selected_card.card_name}}</p>
                                    <p class="mb-0 font-regular body-2 text-14">{{$t('hotel.concierge.the-benefits-you-get')}}</p>
                                  </div>
                                </div>
                              </div>
                              <!-- List -->
                              <div class="pt-3 border-top">
                                <div class="row slim-grid-row mb-2" v-for="benefit_card in selected_card.benefit">
                                  <div class="col-1">
                                    <img src="../../../../assets/img/icon/correct.png" class="position-relative" width="13" style="top: -2px">
                                  </div>
                                  <div class="col-11">
                                    <p class="mb-0 body-2-2 font-semibold text-14">{{benefit_card}}</p>
                                  </div>
                                </div>
                                <!-- Product Reward -->
                                <p class="mb-3 mt-4 font-bold body-2-2 text-18">{{$t('hotel.concierge.the-reward-you-get')}}</p>
                                <div>
                                  <div class="w-100 rounded-6 mb-3 border" v-for="product_slide in selected_card.return_product">
                                    <div class="w-100">
                                      <img :src="product_slide.image_url" class="rounded-6 w-100 object-fit h-slide-reward">
                                      <div class="py-2 px-3">
                                        <p class="mb-0 body-2-2 font-bold text-truncate text-16">{{product_slide.name}}</p>
                                        <div class="row slim-grid-row">
                                          <div class="col-12">
                                            <p class="mb-0 body-2 text-14 font-semibold d-inline-block">{{$t('hotel.concierge.only-for')}} {{selected_card.card_name}}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>  
                                </div>
                              </div>
                            </div>
                            <div style="height: 30px;"></div>
                          </div>
                          <div class="position-relative" v-if="!disabled_register">
                            <div class="row no-gutters justify-content-center">
                              <div class="position-fixed w-100 d-block nav-bottom" style="bottom: 0">
                                <div class="w-100">
                                  <div class="my-2" v-if="error != ''">
                                    <ErrorMessage :message="error" />
                                  </div>
                                  <div class="row justify-content-center no-gutters">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                      <div class="container px-4 w-100 py-2 bg-white">
                                       <button type="button" :disabled="disabled_btn" class="button-primary w-100" @click="show_confirm = true">
                                          <pulse-loader :loading="push_loading" color="#fff" v-if="push_loading"></pulse-loader>
                                          <template v-else>
                                            {{$t('general.register-now')}}
                                          </template>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <warning-box 
      v-if="show_confirm"  
      @yes="pushData"
      @no="show_confirm = false"
      :title="$t('warning-message.register_member.title')"
      :body="$t('warning-message.register_member.message')+' '+selected_card.card_name+' member?'"
      :btn_secondary="$t('general.cancel')"
      :btn_primary="$t('general.continue')">  
    </warning-box>
	</div>
</template>
<script>
  import WarningBox from '@/components/general/WarningBox'
	import MemberCard from '@/components/hotel/concierge/member/MemberCard'
  import {mapGetters} from "vuex";
  import {post} from '@/services/index.js'

	export default{
		props: ['selected_card','guest_name','disabled_btn','disabled_register'],
		components:{
			MemberCard,
      WarningBox
		},
    data(){
      return{
        push_loading: false,
        show_confirm: false,
        error: ''
      }
    },
		methods:{
      ...mapGetters(['getMerchant']),
			close(){
				this.$emit('close')
			},
			parsingDataCard(data){
        let copied = JSON.parse(JSON.stringify(data))
        delete copied.benefit
        delete copied.return_product
        return copied
      },
      pushData(){
        if(!this.push_loading){
          this.show_confirm = false
          this.push_loading = true
          this.error = ''
          this.$emit("push",true)
          post("CONCIERGE","membership/join-request",{
            merchant_id: this.getMerchant().id,
            member_card_id: this.selected_card.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.$emit('done')
            }else{
              this.error = res.message
            }
            this.push_loading = false
            this.$emit("push",false)
          })
        }
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/MemberCardDetail.vue